import { useEffect, useState } from 'react';

/** Current timestamp, refreshed every `intervalMs` — for time-driven UI like progress bars. */
export function useNow(intervalMs: number): number {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), intervalMs);
    return () => clearInterval(id);
  }, [intervalMs]);

  return now;
}
